<template>
    <div class="newList">
        <navTop :isLogin="1" title="相君科技客户案例"></navTop>
        <div class="list">
            <div class="select_mess">
                <div class="select_banner">
                    <div class="select_list" v-for="(item,index) in selectList" :key="index"
                         @click="selectActive = index">
                        {{item.name}}
                        <div class="select_line" v-show="selectActive == index"></div>
                    </div>
                </div>
                <div class="select_listImg" v-if="selectList.length>0" >
                    <div class="img_for" v-for="(item,index) in selectList[selectActive].picPath" :key="index" >
                        <img :src="$global.Local + item"/>
                    </div>
                </div>
            </div>
            <!-- <div class="pagination">
              <el-pagination background layout="prev, pager, next" :total="1000">
              </el-pagination>
              <div class="btn">
                4/100
              </div>
            </div> -->
        </div>


        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                selectActive: 0,
                selectList: [],
            }
        },
        mounted() {
            if (localStorage.getItem('newsAnLi')) {
                console.log(JSON.parse(localStorage.getItem('newsAnLi')), "this.selectListthis.selectListthis.selectListthis.selectList")
                this.selectList = JSON.parse(localStorage.getItem('newsAnLi'));
            } else {
                this.$router.push('/')
            }
        },
        methods: {
            handlCheckNewsDetal() {
                this.$router.push('newsDetal');
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .newList {
        width: @a;
        height: auto;

        .list {
            width: @a;
            height: auto;
            @column();
            padding: 2% 0;

            .select_mess {
                width: 1450px;
                height: auto;

                .select_banner {
                    width: @a;
                    height: 80px;
                    display: flex;
                    justify-content: center;
                    border-bottom: solid 1px #808080;

                    .select_list {
                        width: 150px;
                        height: @a;
                        line-height: 80px;
                        text-align: center;
                        font-size: 25px;
                        color: #333333;
                        font-family: MicrosoftYaHei;
                        cursor: pointer;
                        position: relative;

                        .select_line {
                            width: 100px;
                            height: 3px;
                            background-color: red;
                            position: absolute;
                            left: 25px;
                            bottom: 0;
                        }
                    }

                }

                .select_listImg {
                    width: @a;
                    height: auto;
                    padding: 20px;
                    overflow: hidden;
                    zoom: 1;

                    .img_for {
                        border: solid 1px #808080;
                        width: 230px;
                        height: 100px;
                        margin: 2px;
                        float: left;
                        @row();

                        img {
                            width: 80%;
                            height: 80%;
                            object-fit: cover;
                        }
                    }
                }

                .select_btn {
                    width: @a;
                    height: 50px;
                    @row();
                    margin: 0 0 50px 0;

                    .btn {
                        width: 180px;
                        height: 50px;
                        background-color: #ffffff;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.2);
                        border-radius: 25px;
                        font-family: MicrosoftYaHei;
                        font-size: 24px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 0px;
                        color: #333333;
                        line-height: 50px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }

            .pagination {
                @row();
                margin-top: 30px;

                .btn {
                    width: 80px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background-color: #f4f4f5;
                    letter-spacing: 1px;
                    color: #565656;
                    cursor: pointer;
                }

                /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#005bb0,
                    #005bb0);
                    background-blend-mode: normal,
                    normal;
                }

                /deep/ .el-pager li {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                }

                /deep/ .btn-prev {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                }

                /deep/ .btn-next {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/news/anLi.vue